import React, { useEffect, useState } from 'react';
import CreateEventModal from './CreateEventModal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEvents } from '../../../store/actions/eventActions';
import EventTable from './EventTable';

const Events = () => {

  const dispatch = useDispatch();
  const { loading, events, error } = useSelector((state) => state.events);

  // console.log(events);
  useEffect(() => {
    dispatch(fetchEvents());
  }, [dispatch]);

  const [showModal, setShowModal] = useState(false);

  // Open the modal
  const handleShow = () => setShowModal(true);

  // Close the modal
  const handleClose = () => setShowModal(false);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">Events</h5>
              <span className="p-2"></span>
              <div>
                <span className="p-2"></span>
                <button className="btn btn-success" onClick={handleShow}>
                  Add Event +
                </button>
              </div>
            </div>
            <div className="card-body">
             <EventTable events={events} />
            </div>
          </div>
        </div>
      </div>

      {/* Call Modal Here */}
      <CreateEventModal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default Events;
